<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Tâches')
</script>

<template>
  <q-page padding class="page"> Tâches </q-page>
</template>
